import { AUTHORIZATION_HEADER } from '../../../../../src/authorization';
import { send } from '../../../../../src/network';
import { type ProductDetail } from '../../../../../src/types/ProductDetail';

export type GetProductParams = {
  inventory_date?: string;
  origin?: number;
  productId: number;
};

export function getProductPath({ productId }: GetProductParams) {
  return `/api/v2/products/${productId}/`;
}

export async function getApiV2ProductsId(params: GetProductParams) {
  const queryParams = new URLSearchParams();

  if (params.inventory_date !== undefined) {
    queryParams.append('inventory_date', params.inventory_date);
  }

  if (params.origin !== undefined) {
    queryParams.append('origin', params.origin.toString());
  }

  return await send<ProductDetail>({
    path: getProductPath(params),
    method: 'GET',
    query: queryParams,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
